// SVGs
import React, { ComponentProps, ComponentType } from 'react';

import { RestartAltRounded } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
// MUI icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ApprovalIcon from '@mui/icons-material/Approval';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BackHandIcon from '@mui/icons-material/BackHand';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import CloseIcon from '@mui/icons-material/Close';
import ConstructionIcon from '@mui/icons-material/Construction';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import MuiDeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DeleteOutlineSharpIcon from '@mui/icons-material/DeleteOutlineSharp';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import EastIcon from '@mui/icons-material/East';
import EditIcon from '@mui/icons-material/Edit';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CalendarIcon from '@mui/icons-material/Event';
import ExpandIcon from '@mui/icons-material/Expand';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoIcon from '@mui/icons-material/Info';
import KeyIcon from '@mui/icons-material/Key';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockPersonTwoToneIcon from '@mui/icons-material/LockPersonTwoTone';
import LockResetIcon from '@mui/icons-material/LockReset';
import MenuIcon from '@mui/icons-material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import PublishIcon from '@mui/icons-material/Publish';
import RefreshIcon from '@mui/icons-material/Refresh';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldLessRoundedIcon from '@mui/icons-material/UnfoldLessRounded';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldMoreRoundedIcon from '@mui/icons-material/UnfoldMoreRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

// React icon components in this folder (TSX)
import { ChannelInfoIcon } from './ChannelInfoIcon';
import { ChannelSaveIcon } from './ChannelSaveIcon';
import { CloseThreadIcon } from './CloseThreadIcon';
import { CommandIcon } from './CommandIcon';
import { CreateChannelIcon } from './CreateChannelIcon';
import { EmojiIcon } from './EmojiIcon';
import { HamburgerIcon } from './HamburgerIcon';
import { LightningBoltSmallIcon } from './LightningBoltSmall';
import { SendIcon } from './SendIcon';
import { XButton as XButtonIcon } from './XButton';
import { XButtonBackground as XButtonBackgroundIcon } from './XButtonBackground';
import { ReactComponent as AbsenceRequestIconSVG } from './absence-request.svg';
import { ReactComponent as AccountIcon } from './account.svg';
import { ReactComponent as ActiveIconSVG } from './active.svg';
import { ReactComponent as AlertBlackIconSVG } from './alert-black.svg';
import { ReactComponent as AlertIconSVG } from './alert.svg';
import { ReactComponent as Auth } from './auth.svg';
import { ReactComponent as BackIconSVG } from './back.svg';
//svg
import { ReactComponent as CalenderIconSVG } from './calender.svg';
import { ReactComponent as CheckIconSVG } from './check.svg';
import { ReactComponent as CircleClosedIconSVG } from './circle-closed.svg';
import { ReactComponent as CircleOpenIconSVG } from './circle-open.svg';
import { ReactComponent as Clock } from './clock.svg';
import { CollapseIcon } from './collapse-icon';
import { ReactComponent as ConfigurationIconSVG } from './configuration-icon.svg';
import { ReactComponent as Contact } from './contact.svg';
import { ReactComponent as CopyIconSVG } from './copy.svg';
import { ReactComponent as DashboardOutlined } from './dashboard-outlined.svg';
import { ReactComponent as DashboardWhiteIconSVG } from './dashboard-white.svg';
import { ReactComponent as DashboardIconSVG } from './dashboard.svg';
import { ReactComponent as Database } from './database.svg';
import { ReactComponent as DayShiftIconSVG } from './day-shift.svg';
import { ReactComponent as DayIconSVG } from './day.svg';
import { ReactComponent as DayShiftAltIconSVG } from './dayShift.svg';
import { ReactComponent as DefaultAvatarGeneralIconSVG } from './default-avatar-general.svg';
import { ReactComponent as DefaultAvatarPhotoIconSVG } from './default-avatar-photo.svg';
import { ReactComponent as DeleteIconSVG } from './delete.svg';
import { ReactComponent as DetailViewIconSVG } from './detail-view.svg';
import { ReactComponent as Documents } from './documents.svg';
import { ReactComponent as DollarIconSVG } from './dollar.svg';
import { ReactComponent as PencilIcon } from './edit-pencil.svg';
import { ReactComponent as EditIconSVG } from './edit.svg';
import { ReactComponent as EditCommentIconSVG } from './editComment.svg';
import { ReactComponent as EmployeesIconSVG } from './employees.svg';
import { ReactComponent as EveShiftIconSVG } from './eve-shift.svg';
import { ReactComponent as EveningIconSVG } from './evening.svg';
import { ExpandIcon as ExpandCustomIcon } from './expand-icon';
import { ReactComponent as Filter } from './filter-lines.svg';
import { ReactComponent as FilterIconSVG } from './filter.svg';
import { ReactComponent as FwdIconSVG } from './fwd.svg';
import { ReactComponent as General } from './general.svg';
import { GreyClockIcon } from './grey-clock-icon';
import { ReactComponent as GuideIcon } from './guide.svg';
import { ReactComponent as Health } from './health.svg';
import { ReactComponent as History } from './history.svg';
import { ReactComponent as ImportIcon } from './import.svg';
import { ReactComponent as InService } from './in-service.svg';
// aliased to avoid clash with MUI ExpandIcon
import { ReactComponent as InfoIconSVG } from './info.svg';
import { ReactComponent as Journal } from './journal.svg';
import { ReactComponent as License } from './license.svg';
import { ReactComponent as ListViewIconSVG } from './list-view.svg';
import { ReactComponent as List } from './list.svg';
import { ReactComponent as LockIconRounded } from './lock-rounded.svg';
import { ReactComponent as LockIconSVG } from './lock.svg';
import { LogoHorizontalIcon } from './logo';
import { LogoIcon } from './logo-icon';
import { ReactComponent as Logout } from './logout.svg';
import { ReactComponent as Logs } from './logs.svg';
import { ReactComponent as Misc } from './misc.svg';
import { ReactComponent as MoreHorizontalIconSVG } from './more-horizontal.svg';
import { ReactComponent as MoreVerticalIconSVG } from './more-vertical.svg';
import { ReactComponent as NightShiftIconSVG } from './night-shift.svg';
import { ReactComponent as NightIconSVG } from './night.svg';
import { ReactComponent as OutlinedInfoIcon } from './outlined-info.svg';
import { ReactComponent as OutlinedPlusIcon } from './outlined-plus.svg';
import { ReactComponent as PagingNextIconSVG } from './paging-next.svg';
import { ReactComponent as PagingPrevIconSVG } from './paging-prev.svg';
import { ReactComponent as PayRates } from './pay-rates.svg';
import { ReactComponent as Payroll } from './payroll.svg';
import { ReactComponent as PlusIconSVG } from './plus.svg';
import { ReactComponent as PrintIcon } from './print.svg';
import { ReactComponent as PunchArrowIconSVG } from './punchArrow.svg';
import { ReactComponent as PunchIndicatorIconSVG } from './punchIndicator.svg';
import { ReactComponent as RefreshIconSVG } from './refresh.svg';
import { ReactComponent as ReportsWhiteIconSVG } from './reports-white.svg';
import { ReactComponent as ReportsIconSVG } from './reports.svg';
import {
  RowAuditIcon,
  RowCopyIcon,
  RowDeleteIcon,
  RowEditIcon,
} from './row-action-icons';
import { ReactComponent as SchedulePattern } from './schedule-pattern.svg';
import { ReactComponent as SchedulerIconSVG } from './scheduler-icon.svg';
import { ReactComponent as SchedulingIconSVG } from './scheduling.svg';
import { ReactComponent as SettingsIconSVG } from './settings.svg';
import { ReactComponent as Stats } from './stats.svg';
import { ReactComponent as Status } from './status.svg';
import { ReactComponent as TabSvg } from './tab.svg';
import { ReactComponent as TimeCardsIconSVG } from './time-cards-icon.svg';
import { ReactComponent as ToolsIcon } from './tools.svg';
import { ReactComponent as TrashIcon } from './trash.svg';
import { ReactComponent as UndoIconSVG } from './undo.svg';
import { UnitIcon } from './unit-Icon';
import { ReactComponent as UserPlaceholderIconSVG } from './user-placeholder.svg';
import { ReactComponent as WarningIconSVGOutlined } from './warning-outlined.svg';
import { ReactComponent as WarningIconSVG } from './warning.svg';
import { ReactComponent as WarningAltIconSVG } from './warningIcon.svg';
import { ReactComponent as WorkPattern } from './work-pattern.svg';

type IconBaseConfig = {
  backgroundColor?: string;
};

type SvgIconConfig = IconBaseConfig & {
  type: 'reactSvg';
  Component: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

type MuiIconConfig = IconBaseConfig & {
  type: 'mui';
  Component: React.ComponentType<any>;
};

export type ReactIconConfig<T extends ComponentType<any> = ComponentType<any>> =
  IconBaseConfig & {
    type: 'react';
    Component: T;
    defaultProps?: Partial<ComponentProps<T>>;
  };

type PngIconConfig = IconBaseConfig & {
  type: 'png';
  src: string;
};

type IconConfig =
  | SvgIconConfig
  | MuiIconConfig
  | ReactIconConfig
  | PngIconConfig;

const ICONS_MAP = {
  Account: { type: 'react', Component: AccountIcon },
  License: { type: 'react', Component: License },
  Health: { type: 'react', Component: Health },
  Status: { type: 'react', Component: Status },
  Contact: { type: 'react', Component: Contact },
  PayRates: { type: 'react', Component: PayRates },
  WorkPattern: { type: 'react', Component: WorkPattern },
  InService: { type: 'react', Component: InService },
  Journal: { type: 'react', Component: Journal },
  General: { type: 'react', Component: General },
  Tab: { type: 'reactSvg', Component: TabSvg },
  Clock: { type: 'react', Component: Clock },
  History: { type: 'react', Component: History },
  Auth: { type: 'react', Component: Auth },
  Documents: { type: 'react', Component: Documents },
  Payroll: { type: 'react', Component: Payroll },
  Misc: { type: 'react', Component: Misc },
  SchedulePattern: { type: 'react', Component: SchedulePattern },
  AbsenceRequestSVG: { type: 'reactSvg', Component: AbsenceRequestIconSVG },
  ActiveSVG: { type: 'reactSvg', Component: ActiveIconSVG },
  Add: { type: 'mui', Component: AddIcon },
  AddCircle: { type: 'mui', Component: AddCircleIcon },
  RestartAltRounded: { type: 'mui', Component: RestartAltRounded },
  AddCircleOutlineOutlined: {
    type: 'mui',
    Component: AddCircleOutlineOutlinedIcon,
  },
  AlertSVG: { type: 'reactSvg', Component: AlertIconSVG },
  AlertBlackIconSVG: { type: 'reactSvg', Component: AlertBlackIconSVG },
  Approval: { type: 'mui', Component: ApprovalIcon },
  ArrowDropDown: { type: 'mui', Component: ArrowDropDownIcon },
  ArrowDropDownRounded: { type: 'mui', Component: ArrowDropDownRoundedIcon },
  ArrowDropUp: { type: 'mui', Component: ArrowDropUpIcon },
  ArrowRight: { type: 'mui', Component: ArrowRightIcon },
  ArrowRightRounded: { type: 'mui', Component: ArrowRightRoundedIcon },
  Assessment: { type: 'mui', Component: AssessmentIcon },
  AssignmentTurnedIn: { type: 'mui', Component: AssignmentTurnedInIcon },
  AttachMoney: { type: 'mui', Component: AttachMoneyIcon },
  BackSVG: { type: 'reactSvg', Component: BackIconSVG },
  BackHand: { type: 'mui', Component: BackHandIcon },
  CalenderSVG: { type: 'reactSvg', Component: CalenderIconSVG },
  Calendar: { type: 'mui', Component: CalendarIcon },
  CalendarMonth: { type: 'mui', Component: CalendarMonthIcon },
  CancelRounded: { type: 'mui', Component: CancelRoundedIcon },
  ChannelInfo: { type: 'react', Component: ChannelInfoIcon },
  ChannelSave: { type: 'react', Component: ChannelSaveIcon },
  CheckCircle: { type: 'mui', Component: CheckCircleIcon },
  CheckSVG: { type: 'reactSvg', Component: CheckIconSVG },
  ChevronLeft: { type: 'mui', Component: ChevronLeftIcon },
  ChevronRight: { type: 'mui', Component: ChevronRightIcon },
  ChevronRightRounded: { type: 'mui', Component: ChevronRightRoundedIcon },
  CircleClosedSVG: { type: 'reactSvg', Component: CircleClosedIconSVG },
  CircleOpenSVG: { type: 'reactSvg', Component: CircleOpenIconSVG },
  Close: { type: 'mui', Component: CloseIcon },
  CloseThread: { type: 'react', Component: CloseThreadIcon },
  Collapse: { type: 'react', Component: CollapseIcon },
  Command: {
    type: 'react',
    Component: CommandIcon,
    defaultProps: { fillColor: 'black' },
  },
  ConfigurationSVG: { type: 'reactSvg', Component: ConfigurationIconSVG },
  Construction: { type: 'mui', Component: ConstructionIcon },
  ContactPage: { type: 'mui', Component: ContactPageIcon },
  ContentCopy: { type: 'mui', Component: ContentCopyIcon },
  CopySVG: { type: 'reactSvg', Component: CopyIconSVG },
  CreateChannel: { type: 'react', Component: CreateChannelIcon },
  CreateOutlined: { type: 'mui', Component: CreateOutlinedIcon },
  DashboardSVG: { type: 'reactSvg', Component: DashboardIconSVG },
  DashboardOutlined: { type: 'react', Component: DashboardOutlined },
  Database: { type: 'react', Component: Database },
  List: { type: 'react', Component: List },
  Stats: { type: 'react', Component: Stats },
  Logs: { type: 'react', Component: Logs },
  DashboardWhiteSVG: { type: 'reactSvg', Component: DashboardWhiteIconSVG },
  DaySVG: { type: 'reactSvg', Component: DayIconSVG },
  DayShiftSVG: { type: 'reactSvg', Component: DayShiftIconSVG },
  DayShiftAltSVG: { type: 'reactSvg', Component: DayShiftAltIconSVG },
  DefaultAvatarPhotoSVG: {
    type: 'reactSvg',
    Component: DefaultAvatarPhotoIconSVG,
  },
  DefaultAvatarGeneralSVG: {
    type: 'reactSvg',
    Component: DefaultAvatarGeneralIconSVG,
  },
  DeleteSVG: { type: 'reactSvg', Component: DeleteIconSVG },
  Delete: { type: 'mui', Component: MuiDeleteIcon },
  MuiDeleteIcon: { type: 'mui', Component: MuiDeleteIcon as any },
  DeleteForever: { type: 'mui', Component: DeleteForeverIcon },
  DeleteOutline: { type: 'mui', Component: DeleteOutlineIcon },
  DeleteOutlineOutlined: {
    type: 'mui',
    Component: DeleteOutlineOutlinedIcon,
  },
  DeleteOutlineSharp: { type: 'mui', Component: DeleteOutlineSharpIcon },
  DetailViewSVG: { type: 'reactSvg', Component: DetailViewIconSVG },
  DesktopWindowsOutlined: {
    type: 'mui',
    Component: DesktopWindowsOutlinedIcon,
  },
  DollarSVG: { type: 'reactSvg', Component: DollarIconSVG },
  DriveFileRenameOutline: {
    type: 'mui',
    Component: DriveFileRenameOutlineIcon,
  },

  East: { type: 'mui', Component: EastIcon },
  Edit: { type: 'mui', Component: EditIcon },
  EditCalendar: { type: 'mui', Component: EditCalendarIcon },
  EditCommentSVG: { type: 'reactSvg', Component: EditCommentIconSVG },
  EditOutlined: { type: 'mui', Component: EditOutlinedIcon },
  EditSVG: { type: 'reactSvg', Component: EditIconSVG },
  Emoji: {
    type: 'react',
    Component: EmojiIcon,
    defaultProps: { fillColor: 'black' },
  },
  EmployeesSVG: { type: 'reactSvg', Component: EmployeesIconSVG },
  Error: { type: 'mui', Component: ErrorIcon },
  ErrorOutline: { type: 'mui', Component: ErrorOutlineIcon },
  EveShiftSVG: { type: 'reactSvg', Component: EveShiftIconSVG },
  EveningSVG: { type: 'reactSvg', Component: EveningIconSVG },
  Expand: { type: 'mui', Component: ExpandIcon },
  ExpandCircleDown: { type: 'mui', Component: ExpandCircleDownIcon },
  ExpandCustom: { type: 'react', Component: ExpandCustomIcon },
  ExpandLess: { type: 'mui', Component: ExpandLessIcon },
  ExpandMore: { type: 'mui', Component: ExpandMoreIcon },
  Filter: { type: 'reactSvg', Component: Filter },
  FilterAlt: { type: 'mui', Component: FilterAltIcon },
  FilterAltOutlined: { type: 'mui', Component: FilterAltOutlinedIcon },
  FilterSVG: { type: 'reactSvg', Component: FilterIconSVG },
  FwdSVG: { type: 'reactSvg', Component: FwdIconSVG },
  GreyClock: { type: 'react', Component: GreyClockIcon },

  Hamburger: {
    type: 'react',
    Component: HamburgerIcon,
    defaultProps: { fillColor: 'black' },
  },
  HighlightOff: { type: 'mui', Component: HighlightOffIcon },

  Info: { type: 'mui', Component: InfoIcon },
  InfoSVG: { type: 'reactSvg', Component: InfoIconSVG },

  Key: { type: 'mui', Component: KeyIcon },
  KeyboardArrowDown: { type: 'mui', Component: KeyboardArrowDownIcon },
  KeyboardArrowDownRoundedIcon: {
    type: 'mui',
    Component: KeyboardArrowDownRoundedIcon,
  },
  KeyboardArrowUp: { type: 'mui', Component: KeyboardArrowUpIcon },

  LightningBoltSmall: {
    type: 'react',
    Component: LightningBoltSmallIcon,
    defaultProps: { fillColor: 'black' },
  },
  ListViewIconSVG: { type: 'reactSvg', Component: ListViewIconSVG },
  LockOpen: { type: 'mui', Component: LockOpenIcon },
  LockPersonTwoTone: { type: 'mui', Component: LockPersonTwoToneIcon },
  LockReset: { type: 'mui', Component: LockResetIcon },
  LockSVG: { type: 'reactSvg', Component: LockIconSVG },
  LockRounded: { type: 'react', Component: LockIconRounded },
  LogoSVG: { type: 'reactSvg', Component: LogoHorizontalIcon },
  LogoIconSVG: { type: 'reactSvg', Component: LogoIcon },
  Logout: { type: 'mui', Component: Logout },

  Menu: { type: 'mui', Component: MenuIcon },
  MoreHorizontal: { type: 'reactSvg', Component: MoreHorizontalIconSVG },
  MoreVertical: { type: 'reactSvg', Component: MoreVerticalIconSVG },
  MoreVert: { type: 'mui', Component: MoreVertIcon },

  NightSVG: { type: 'reactSvg', Component: NightIconSVG },
  NightShiftSVG: { type: 'reactSvg', Component: NightShiftIconSVG },
  Notifications: { type: 'mui', Component: NotificationsIcon },

  PagingNextSVG: { type: 'reactSvg', Component: PagingNextIconSVG },
  PagingPrevSVG: { type: 'reactSvg', Component: PagingPrevIconSVG },
  PhoneIphoneOutlined: {
    type: 'mui',
    Component: PhoneIphoneOutlinedIcon,
  },
  PlusSVG: { type: 'reactSvg', Component: PlusIconSVG },
  Publish: { type: 'mui', Component: PublishIcon },
  PunchArrowSVG: { type: 'reactSvg', Component: PunchArrowIconSVG },
  PunchIndicatorSVG: { type: 'reactSvg', Component: PunchIndicatorIconSVG },

  RefreshSVG: { type: 'reactSvg', Component: RefreshIconSVG },
  Refresh: { type: 'mui', Component: RefreshIcon },
  ReportsSVG: { type: 'reactSvg', Component: ReportsIconSVG },
  ReportsWhite: { type: 'reactSvg', Component: ReportsWhiteIconSVG },

  SaveAs: { type: 'mui', Component: SaveAsIcon },
  SchedulerSVG: { type: 'reactSvg', Component: SchedulerIconSVG },
  SchedulingSVG: { type: 'reactSvg', Component: SchedulingIconSVG },
  Search: { type: 'mui', Component: SearchIcon },
  Send: {
    type: 'react',
    Component: SendIcon,
    defaultProps: { fillColor: 'black' },
  },
  Settings: { type: 'mui', Component: SettingsIcon },
  SettingsApplications: {
    type: 'mui',
    Component: SettingsApplicationsIcon,
  },
  SettingsSVG: { type: 'reactSvg', Component: SettingsIconSVG },
  SupportAgent: { type: 'mui', Component: SupportAgentIcon },

  TimeCardsSVG: { type: 'reactSvg', Component: TimeCardsIconSVG },

  UndoSVG: { type: 'reactSvg', Component: UndoIconSVG },
  UnfoldLess: { type: 'mui', Component: UnfoldLessIcon },
  UnfoldLessRounded: {
    type: 'mui',
    Component: UnfoldLessRoundedIcon,
  },
  UnfoldMore: { type: 'mui', Component: UnfoldMoreIcon },
  UnfoldMoreRounded: { type: 'mui', Component: UnfoldMoreRoundedIcon },
  Unit: { type: 'react', Component: UnitIcon },
  UserPlaceholderSVG: { type: 'reactSvg', Component: UserPlaceholderIconSVG },

  Visibility: { type: 'mui', Component: VisibilityIcon },
  VisibilityOff: { type: 'mui', Component: VisibilityOffIcon },
  ArrowRightAltIcon: { type: 'mui', Component: ArrowRightAltIcon },

  WarningSVG: { type: 'reactSvg', Component: WarningIconSVG },
  WarningSVGOutlined: { type: 'reactSvg', Component: WarningIconSVGOutlined },
  WarningAltSVG: { type: 'reactSvg', Component: WarningAltIconSVG },

  XButton: {
    type: 'react',
    Component: XButtonIcon,
    defaultProps: { fillColor: 'black' },
  },
  XButtonBackground: { type: 'react', Component: XButtonBackgroundIcon },
  OutlinedInfo: { type: 'reactSvg', Component: OutlinedInfoIcon },
  TrashIcon: { type: 'reactSvg', Component: TrashIcon },
  OutlinedPlus: { type: 'reactSvg', Component: OutlinedPlusIcon },
  Pencil: { type: 'reactSvg', Component: PencilIcon },
  Print: { type: 'reactSvg', Component: PrintIcon },
  Import: { type: 'reactSvg', Component: ImportIcon },
  Tools: { type: 'reactSvg', Component: ToolsIcon },
  Guide: { type: 'reactSvg', Component: GuideIcon },
  RowAuditSVG: { type: 'reactSvg', Component: RowAuditIcon },
  RowDeleteSVG: { type: 'reactSvg', Component: RowDeleteIcon },
  RowEditSVG: { type: 'reactSvg', Component: RowEditIcon },
  RowCopySVG: { type: 'reactSvg', Component: RowCopyIcon },
} as const satisfies Record<string, IconConfig>;

export { ICONS_MAP };
export type { IconConfig };
